import { MapPin } from "lucide-react";

const AREAS = [
  { region: "New South Wales", cities: ["Sydney", "Parramatta", "Newcastle", "Wollongong"] },
  { region: "Victoria", cities: ["Melbourne", "Geelong", "Ballarat", "Bendigo"] },
  { region: "Queensland", cities: ["Brisbane", "Gold Coast", "Sunshine Coast", "Townsville"] },
  { region: "Western Australia", cities: ["Perth", "Fremantle", "Mandurah"] },
  { region: "South Australia", cities: ["Adelaide", "Mount Gambier"] },
  { region: "ACT", cities: ["Canberra"] },
];

export default function ServiceAreas() {
  return (
    <section
      id="areas"
      data-testid="service-areas-section"
      className="py-20 md:py-28 bg-brand-bone"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="max-w-2xl">
          <span className="text-xs uppercase tracking-[0.22em] text-brand-terracotta font-semibold">
            Where we work
          </span>
          <h2 className="mt-3 font-heading font-semibold tracking-tight text-brand-forest text-3xl sm:text-4xl lg:text-5xl">
            Supporting communities across Australia.
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {AREAS.map((a) => (
            <div
              key={a.region}
              data-testid={`area-${a.region.toLowerCase().replace(/\s+/g, "-")}`}
              className="bg-white rounded-2xl border border-brand-sand p-7 hover:border-brand-forest/40 transition-colors"
            >
              <div className="flex items-center gap-2 text-brand-forest">
                <MapPin className="h-5 w-5" />
                <h3 className="font-heading text-lg font-semibold">{a.region}</h3>
              </div>
              <ul className="mt-4 flex flex-wrap gap-2">
                {a.cities.map((c) => (
                  <li
                    key={c}
                    className="text-xs font-medium text-brand-forest bg-brand-forest/5 border border-brand-forest/15 rounded-full px-3 py-1.5"
                  >
                    {c}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p className="mt-10 text-sm text-brand-muted">
          Don’t see your suburb? <a href="#contact" data-testid="areas-contact-link" className="font-semibold text-brand-forest underline-offset-4 hover:underline">Send us a note</a> — we’re expanding rapidly.
        </p>
      </div>
    </section>
  );
}
